import httpClient from './_httpClient';

const END_POINT = '/scopes-emails';
function endpoint(scopeId) {
  return "scopes/" + scopeId + "/emails"
}

const getScopeEmails = (scope_id) => httpClient.get(endpoint(scope_id));
const updateScopeEmails = (scope_id, emails) => httpClient.put(endpoint(scope_id), emails);

export {
  getScopeEmails,
  updateScopeEmails,
}
